import { infiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';

import type { ConversationsListFilter, GetLastConversationsInfiniteQueryProps } from './chatService';

import { ChatService } from './chatService';
import { ChatKey } from './keys';

export function getLastConversationsInfiniteOptions(name?: string, type?: ConversationsListFilter) {
  return infiniteQueryOptions({
    queryKey: [ChatKey.CHAT_LAST_CONVERSATIONS_INFINITE, name, type],
    queryFn: ({ pageParam }) => ChatService.getLastConversations({ ...pageParam, name, type }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 10, name: undefined },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}

export function useGetLastConversationsInfinite(props: GetLastConversationsInfiniteQueryProps) {
  const { name, type } = props;

  return useInfiniteQuery(getLastConversationsInfiniteOptions(name, type));
}
